export default {
    mixins: [],
    data: () => ({

    }),
    computed: {

    },
    methods: {
        showMenu() {
            document.querySelector("#SideBar").classList.remove("hidden");
            setTimeout(function() {
                document.querySelector("#sideContent").classList.remove("md:-right-1/3");
                document.querySelector("#sideContent").classList.remove("-right-full");
                document.querySelector("#sideContent").classList.add("right-0");
            }, 50);

        },
        closeMenu() {
            document.querySelector("#sideContent").classList.remove("right-0");
            document.querySelector("#sideContent").classList.add("-right-full");
            document.querySelector("#sideContent")
                .classList.add("md:-right-1/3");
            setTimeout(function() {
                document.querySelector("#SideBar").classList.add("hidden");
            }, 300);
        }
    }
};